import { IApprovalProccessId } from "../../../types"
import { getApprovalActorAccess } from "../../shared/utils/approvalAccess"

interface ISupplierEditAccess {
  isApprover: boolean
  isPic: boolean
  canEdit: boolean
}

export const getSupplierEditAccess = (
  approvalProcess: IApprovalProccessId | null | undefined,
  employeeId: string | null | undefined,
): ISupplierEditAccess => {
  const approvalAccess = getApprovalActorAccess(approvalProcess, employeeId)

  return {
    isApprover: approvalAccess.isApprover,
    isPic: approvalAccess.isPic,
    canEdit: approvalAccess.isApprover || approvalAccess.isPic,
  }
}
